import { Injectable, inject } from '@angular/core';
import { SiaHttpService } from '@sia/shared';
import { SiaMcpCollection } from '../interfaces/mcp-tools';

@Injectable({
  providedIn: 'root',
})
export class SiaAIPromptApi {
  #http = inject(SiaHttpService);

  private readonly aiPromptController: string = 'chat-ai';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  applyPrompt(promptId: number, parameters: any): Promise<string> {
    return this.#http.post(
      `${this.aiPromptController}/prompt/${promptId}`,
      parameters,
    );
  }

  chat(
    chatUniqueId: string,
    componentType: string,
    componentId: string,
    mode: string,
    hubId: string,
    prompt: string,
    collectionId: string,
    deviceType: string,
    files: { base64: string; mimeType: string }[],
    llmChatHistory: { role: 'user' | 'assistant'; content: string }[],
    selectedDocumentationCategories?: string[],
    selectedChatDocuments: string[] | null = null,
    requestId?: string,
  ): Promise<string> {
    return this.#http.post(
      `${this.aiPromptController}/chat`,
      {
        chatUniqueId: chatUniqueId,
        componentType: componentType,
        componentId: componentId,
        mode: mode,
        signalrSessionId: hubId,
        prompt: prompt,
        collectionId: collectionId,
        deviceType: deviceType,
        ImageAttachments: files,
        llmChatHistory: llmChatHistory,
        selectedDocumentationCategories: selectedDocumentationCategories,
        selectedChatDocument: selectedChatDocuments,
        requestId: requestId, // Include requestId in the payload
      },
      {},
      undefined,
      requestId, // Also pass as HTTP request ID for client-side abort
    );
  }

  retrieveCollections(): Promise<SiaMcpCollection[]> {
    return this.#http.get(`${this.aiPromptController}/collections`);
  }

  retrieveOriginInformation(type: string, fileSha256: string): Promise<any> {
    if (
      type === 'pdf' ||
      type === 'doc' ||
      type === 'docx' ||
      type == 'raw_image'
    ) {
      return this.#http.execDownload(
        `${this.aiPromptController}/preview/${type}/${fileSha256}`,
        {},
      );
    }
    return this.#http.get(
      `${this.aiPromptController}/preview/${type}/${fileSha256}`,
    );
  }

  getDocumentationCategories(): any {
    return this.#http.get(
      `${this.aiPromptController}/documentation-categories`,
    );
  }

  downloadDocument(fileSha256: string): Promise<Blob> {
    return this.#http.execDownload(
      `${this.aiPromptController}/download-document/${fileSha256}`,
      {},
    );
  }

  retrieveFileTextContent(sha256: string): Promise<{ textContent: string }> {
    return this.#http.get(`ai-files-grid/text-content/${sha256}`);
  }
}
